import { Link } from "react-router-dom";

export default function BackToWarehouseInventoryLink({ warehouse }) {
  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        <li className="breadcrumb-item">
          <Link to={`/warehouses/${warehouse.id}/inventory`}>
            <i className="fa-regular fa-circle-left"></i> Kembali ke {warehouse.name}
          </Link>
        </li>
      </ol>
    </nav>
  );
}
